import { render, staticRenderFns } from "./PeriodSelection.vue?vue&type=template&id=20b3a98e&scoped=true"
import script from "./PeriodSelection.vue?vue&type=script&lang=js"
export * from "./PeriodSelection.vue?vue&type=script&lang=js"
import style0 from "./PeriodSelection.vue?vue&type=style&index=0&id=20b3a98e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20b3a98e",
  null
  
)

export default component.exports